import { object, z } from 'zod/v4-mini';

import { GeneralBackendResponseSchema } from '$/services/mapper/authentication';
import { MaterialTypeSchema } from '$/services/usecases/materials/mapper/materials';

export const FavoriteSchema = z.object({
  materialId: z.string(),
  parentFolderIds: z.array(z.string()),
  isGlobalFavoriteMaterial: z.boolean(),
});

export const FavoriteFolderSectionSchema = z.object({
  id: z.string(),
  title: z.optional(z.string()),
  materialType: MaterialTypeSchema,
  favoriteIds: z.array(z.string()),
});

export type FavoriteFolderSection = z.infer<typeof FavoriteFolderSectionSchema>;

export const FavoriteFolderSchema = z.object({
  name: z.string(),
  id: z.string(),
  isGlobalFavoriteFolder: z._default(z.boolean(), false),
  hasThumbnail: z._default(z.boolean(), false),
  materialOrder: z._default(z.array(z.string()), []),
  sections: z.optional(z.array(FavoriteFolderSectionSchema)),
});

export const GetFavoritesResponseSchema = object({
  ...GeneralBackendResponseSchema,
  payload: z.optional(
    object({
      favoriteFolders: z.array(FavoriteFolderSchema),
      globalFavoriteFolders: z.array(FavoriteFolderSchema),
      favoriteMaterials: z.array(FavoriteSchema),
    }),
  ),
});

export const CreateFavoriteFolderResponseSchema = object({
  ...GeneralBackendResponseSchema,
  payload: z.optional(FavoriteFolderSchema),
});

export type GetFavoritesResponse = z.infer<typeof GetFavoritesResponseSchema>;
